'use strict';

module.exports = '2.24.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 234
// module chunks = 114276838955818